module.exports = function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' &&
    Object.getPrototypeOf(value) === Object.prototype;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stamp/is/plain-object.js
// module id = 237
// module chunks = 0